import React from 'react';
import {SelectWrapper} from './type/SelectStructure';
import {FormikAsyncSelect} from './type/async-select/FormikAsyncSelect';
import {FormControlWrapper} from '../FormControlStructure';
import {RawAsyncSelect} from './type/async-select/RawAsyncSelect';

export function AsyncSelect({raw, ...props}) {
    if (raw) {
        return <RawAsyncSelect {...props} menuPortalTarget={document.body} />;
    } else {
        return <FormikAsyncSelect {...props} menuPortalTarget={document.body} />;
    }
}

AsyncSelect.Wrapper = SelectWrapper;
AsyncSelect.FormGroup = FormControlWrapper;
